import React, { Component } from 'react'

export class ThirdScreen extends Component {
    render() {
        return (
            <div>
                <div className="m-body">
                    <img className="m-headerLogo" src={require("../../assets/imgs/logo-blue.png")} alt="logo" />
                    <span className="m-home-text">Tap Once and Select the Answer<br />
                        That Suits Best Your Situation<br />
                        Easy and Simple!</span>
                    <img className="m-tutorial" src={require("../../assets/imgs/mobile/tutorial.png")} alt="tutorial" />
                    <img alt="snake-small" className="m-white-snake2" src={require("../../assets/imgs/mobile/snake.png")} />
                </div>
                <div className="m-bullet-list goNextBigger">
                    <div className="m-bullet"></div>
                    <div className="m-bullet"></div>
                    <div className="m-bullet selected-bullet"></div>
                    <div className="m-bullet"></div>
                </div>
                <p onClick={this.props.nextStep} className="goNext goNextBigger">Next -></p>
            </div>
        )
    }
}

export default ThirdScreen
